// const URL = 'https://meloa-staging.inesctec.pt'
const URL = 'https://meloa.inesctec.pt'
// const URL = 'https://localhost';
  
export default {
  MAP_GOOGLE_KEY: 'AIzaSyB7DgboLb_ybkgObTqlSg0w_5Wh5UH_gXk',
  URL,
  API_URL: `${URL}/public`
}